import { render, staticRenderFns } from "./Easter.vue?vue&type=template&id=229017f1&"
import script from "./Easter.vue?vue&type=script&lang=js&"
export * from "./Easter.vue?vue&type=script&lang=js&"
import style0 from "./Easter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports